<svelte:head>
        <link
    rel="stylesheet"
    href="https://unpkg.com/carbon-components-svelte/css/white.css"
/>
</svelte:head>

<script>
    export let page;
    import { onMount } from 'svelte';
    import {
        Header,
        HeaderUtilities,
        HeaderAction,
        HeaderGlobalAction,
        HeaderPanelLinks,
        HeaderPanelDivider,
        HeaderPanelLink,
        SideNav,
        SideNavItems,
        SideNavMenu,
        SideNavMenuItem,
        SideNavLink,
        SkipToContent,
        Content,
        Grid,
        Row,
        Column,
        Modal,
        Form,
        FormGroup,
        TextInput,
        TextArea,
    } from "carbon-components-svelte";
    import jwt_decode from "jwt-decode";
    import Menu16 from "carbon-icons-svelte/lib/Menu16";
    import Close16 from "carbon-icons-svelte/lib/Close16";
    import TaskAdd20 from "carbon-icons-svelte/lib/TaskAdd20";
    import Login20 from "carbon-icons-svelte/lib/Login20";
    import { user, addTask } from "../store.js";
    import Alert from "./Alert.svelte";

    let isSideNavOpen = true;
    let RightNavBarOpen = false;
    let newthoughttitle;
    let newthoughtdescription;
    let open = false;

    function createThought() {
        console.log("createThought: init");
        const data = {
            name: newthoughttitle,
            description: newthoughtdescription,
        };
        addTask(data);
        console.log("createThought: reset");
        newthoughttitle = "";
        newthoughtdescription = "";
        open = false;
    }

</script>

<Header
    persistentHamburgerMenu={true}
    company="MTE"
    platformName="Mech Tech Engineering"
    bind:isSideNavOpen
    aria-label="SideNav2"
>
    <HeaderUtilities>
        <HeaderGlobalAction
            aria-label="Add a task"
            icon={TaskAdd20}
            bind:open
            on:click={() => (open = true)}
        />
        {#if $user.logged_in == false}
            <HeaderGlobalAction
                aria-label="Login"
                on:click={() => (page = "login")}
                icon={Login20}
            />
	
        {:else}
            <HeaderAction
                icon={RightNavBarOpen ? Close16 : Menu16}
                bind="RightNavBarOpen"
                aria-label="User"
            >
                <HeaderPanelLinks>
                    <HeaderPanelDivider>Configure</HeaderPanelDivider>
                    <HeaderPanelLink
                        aria-label="Context"
                        on:click={() => {
                            RightNavBarOpen = false;
                            page = "context";
                        }}>Context</HeaderPanelLink
                    >
                    <HeaderPanelLink
                        aria-label="Topics"
                        on:click={() => {
                            RightNavBarOpen = false;
                            page = "topics";
                        }}>Topics</HeaderPanelLink
                    >
                    <HeaderPanelLink>Tags</HeaderPanelLink>
                    <HeaderPanelDivider>Users</HeaderPanelDivider>
                    <HeaderPanelLink>Delegate List</HeaderPanelLink>
                    <HeaderPanelLink>Shared list</HeaderPanelLink>
                    <HeaderPanelDivider>Account</HeaderPanelDivider>
                    <HeaderPanelLink>User Details</HeaderPanelLink>
                    <HeaderPanelLink on:click={() => {user.set({logged_in: false}); page = 'login'}}
                        >Logout</HeaderPanelLink
                    >
                </HeaderPanelLinks>
            </HeaderAction>
        {/if}
    </HeaderUtilities>
</Header>
<SideNav bind:isOpen={isSideNavOpen} aria-label="SideNav">
    <SideNavItems>
        <SideNavLink
            text="Inbox"
            aria-label="Inbox"
            on:click={() => {
                isSideNavOpen = false;
                page = "inbox";
            }}
        />
        <SideNavLink
            text="Next"
            aria-label="Next"
            on:click={() => {
                isSideNavOpen = false;
                page = "next";
            }}
        />
        <SideNavMenu text="Tasks" aria-label="Tasks">
            <SideNavMenuItem
                text="Active"
                aria-label="Active"
                on:click={() => {
                    isSideNavOpen = false;
                    page = "active";
                }}
            />
            <SideNavMenuItem
                text="Delegated"
                aria-label="Delegated"
                on:click={() => {
                    isSideNavOpen = false;
                    page = "delegated";
                }}
            />
            <SideNavMenuItem
                text="Scheduled"
                aria-label="Scheduled"
                on:click={() => {
                    isSideNavOpen = false;
                    page = "scheduled";
                }}
            />
            <SideNavMenuItem
                text="Completed"
                aria-label="Completed"
                on:click={() => {
                    isSideNavOpen = false;
                    page = "completed";
                }}
            />
            <SideNavMenuItem
                text="Someday"
                aria-label="Someday"
                on:click={() => {
                    isSideNavOpen = false;
                    page = "someday";
                }}
            />
        </SideNavMenu>
        <SideNavMenu text="Projects" aria-label="Projects">
            <SideNavMenuItem
                text="Active"
                aria-label="Active Projects"
                on:click={() => {
                    isSideNavOpen = false;
                    page = "projects-active";
                }}
            />
            <SideNavMenuItem
                href="/"
                text="Shared"
                aria-label="Shared Projects"
            />
            <SideNavMenuItem
                href="/"
                text="Archived"
                aria-label="Archived Projects"
            />
            <SideNavMenuItem
                href="/"
                text="Templated"
                aria-label="Project Templates"
            />
        </SideNavMenu>
    </SideNavItems>
</SideNav>

<Content>
    <!-- <Button on:click={() => (open = true)}>Create database</Button> -->

    <Modal
        bind:open
        modalHeading="Add thought"
        primaryButtonText="Add"
        secondaryButtonText="Cancel"
        on:click:button--secondary={() => (open = false)}
        on:open
        on:close
        on:submit={createThought}
    >
        <Form on:submit>
            <FormGroup legendText="Add a thought for later review">
                <TextInput
                    id="thoughtInput"
                    labelText="Thought"
                    bind:value={newthoughttitle}
                />
                <TextArea
                    id="thoughtDescription"
                    labelText="description"
                    bind:value={newthoughtdescription}
                />
            </FormGroup>
        </Form>
    </Modal>

    <Grid>
        <Row>
            <Column>
                 <Alert />
            </Column>
        </Row>
        <Row>
            <Column>
                <slot name="content">No data passed</slot>
            </Column>
        </Row>
    </Grid>
</Content>
